import { useEffect } from 'react'

import { WidgetTourConfig } from '../models'
import { useWidgetTourContext } from '../shared/WidgetTourContext'

export const useRegisterWidgetTours = (tours: WidgetTourConfig[]): void => {
  const { registerTour, unregisterTour } = useWidgetTourContext()

  useEffect(() => {
    tours.forEach(registerTour)

    return () => {
      tours.forEach((tour) => unregisterTour(tour.id))
    }
  }, [registerTour, tours, unregisterTour])
}
